module.exports = __webpack_public_path__ + "static/grafika4@2x-e2cfe52124359bcd519e983dcc14d5f6.png";